import React, { FC } from 'react'

import { PaymentMethodIcon } from '../PaymentMethodIcon/PaymentMethodIcon'
import { PaymentStatus } from '../PaymentStatus/PaymentStatus'
import { PriceItem } from '../../../../components/common/price/PriceItem'

import { cn } from '../../../../lib/utils'

import { IPaymentStatus, IPaymentType } from '../../../../types/payment'

interface ReceiptItemProps {
  title: string
  selectedCount?: number
  description?: string
  price: number
  originalPrice: number
  paidDate: Date | string | null
  cardNo?: string | null
  amountRefunded: number
  refundedDate: Date | null
  paymentType: IPaymentType
  paymentStatus: IPaymentStatus
  isScratched: boolean
  scratchedDate: Date | null
  isRefunded: boolean
  isQualify?: boolean | null
  qualifyFee?: string | null
  qualifyFeeName?: string | null
  ownerId: string | null
  ownerName: string | null
  recipientId: string | null
  recipientName: string | null
  currency: string
}

export const ReceiptItem: FC<ReceiptItemProps> = ({
  title,
  selectedCount,
  description,
  price,
  originalPrice,
  paidDate,
  cardNo,
  amountRefunded,
  paymentType,
  paymentStatus,
  isScratched,
  scratchedDate,
  isRefunded,
  refundedDate,
  isQualify,
  qualifyFee,
  qualifyFeeName,
  ownerId,
  ownerName,
  recipientId,
  recipientName,
  currency,
}) => {
  return (
    <>
      <div className="py-2 rounded-lg break-inside-avoid">
        <div className="flex justify-between items-start gap-2">
          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <p className="text-sm font-medium flex flex-wrap items-center gap-1">
                <span className={cn(isScratched && 'line-through')}>{title}</span>{' '}
                <span className="text-gray-500 font-normal">
                  {selectedCount
                    ? `(${selectedCount} item${selectedCount !== 1 ? 's' : ''})`
                    : null}
                </span>
              </p>
            </div>
            <p className="text-xs text-gray-500">{description}</p>
            <div className="flex flex-wrap items-center gap-2 mt-1 text-xs">
              {paymentType && (
                <PaymentMethodIcon
                  paymentType={paymentType}
                  cardNumber={cardNo}
                  className="font-normal"
                />
              )}
            </div>
          </div>
          <div className="flex flex-col items-end text-right">
            <div className="flex gap-2">
              <PriceItem
                isRefunded={isRefunded}
                amountRefunded={amountRefunded}
                price={price}
                originalPrice={originalPrice}
                qualifyFee={qualifyFee}
                isQualify={isQualify}
                qualifyFeeName={qualifyFeeName}
                currency={currency}
              />
            </div>
            <PaymentStatus
              isAdjusted={!!originalPrice}
              isRefunded={isRefunded || false}
              isScratched={isScratched || false}
              paymentStatus={paymentStatus}
              paymentType={paymentType}
              scratchedDate={scratchedDate || null}
              refundedDate={refundedDate || null}
              paidDate={paidDate || null}
              ownerId={ownerId || null}
              ownerName={ownerName || null}
              recipientId={recipientId || null}
              recipientName={recipientName || null}
            />
          </div>
        </div>
      </div>
    </>
  )
}
